// extracted by mini-css-extract-plugin
export default {"price":"i7-z","onSale":"j7-z","msrpLabelPrice":"k7-z","msrpLabel":"l7-z","originalPrice":"m7-z","percentOff":"n7-z"};